// Page-wide "address search is off" latch (#689). One 503 from the proxy means
// Oracle/Google is unavailable for everyone, so every AddressSearch on the page
// hides for the rest of the session — the manual fields underneath keep working.
// Lives outside the component so all instances share it and specs can reset it.
let unavailable = false

export function isUnavailable () { return unavailable }
export function markUnavailable () { unavailable = true }
export function resetUnavailable () { unavailable = false }
